export const mapRouterList = [
  { name: 'applyCenter', key: null, pcName: 'sign' },
  { name: 'applyDetail', key: 'many', pcName: 'signDetail?id=' },
  { name: 'community', key: null, pcName: 'community/communityHome' },
  { name: 'communityDetail', key: 'many', pcName: 'community/communityPlate' },
  { name: 'tabCommonView', key: null, pcName: 'community/communityPlate?id=' },
  { name: 'comDetailLevel', key: 'many', pcName: 'community/communityDetail?boardType=1&id=' },
  { name: 'rollVideo', key: 'many', pcName: 'community/communityDetail' },
  { name: 'course', key: null, pcName: 'resource/dailyLesson' },
  { name: 'courseDetail', key: 'many', pcName: 'resource/courseDetails?' }, // -------- id=&fileType=&channel=
  { name: 'ExamInfo', key: 'many', pcName: 'exam/examEntrance?examId=' },
  { name: 'surveyInfo', key: 'many', pcName: 'survey/surveyEntrance?surveyId=' },
  { name: 'surveyDetails', key: 'many', pcName: 'survey/surveyView?surveyId=' },
  { name: 'trainingDetail', key: 'many', pcName: 'train/trainPage?taskId=' },
  { name: 'task', key: null, pcName: 'studyTask' },
  { name: 'broadcast', key: 'many', pcName: 'fieldTrends?ids=&dataShowRule=1' },
  { name: 'broadcastDetail', key: 'many', pcName: 'trendsDetail?id=' },
  { name: 'login', key: 'query.redirect', pcName: 'login?redirect=' },
  { name: 'enterpriseLogin', key: 'query.redirect', pcName: 'login?redirect=' },
  { name: 'home', key: null, pcName: 'home' },
  { name: 'live', key: 'live', pcName: 'live/auth' },
  { name: 'selfRegistrationDetail', key: 'many', pcName: 'signAuto?id=' },
  { name: 'examPractiseInfo', key: 'many', pcName: 'practice?practiceId=' },
  { name: 'lecturerCenter', key: null, pcName: 'lecturer' },
  { name: 'lecturerDetail', key: 'many', pcName: 'lecturerDetail?lecturerId=' },
  { name: 'faceDetail', key: 'many', pcName: 'faceDetail?faceId=' },
  { name: 'signDetail', key: 'many', pcName: 'faceConfirm?trainConfirmId=' }
]
